import { TabOrderRowViewModel } from './TabOrderViewModel'

const TabOrderRowsViewModel = (tabOrder) => tabOrder.map(TabOrderRowViewModel)

export { TabOrderRowsViewModel }
